export default function getContext() {
  if (typeof window === 'undefined') {
    if (typeof global === 'undefined') {
      return {};
    }
    return global;
  }
  return window;
}